import { useTranslation } from 'react-i18next';

export default function ConnaitreQuartier() {
  const { t } = useTranslation('saintromuald');

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          {/* Texte */}
          <div className="order-2 lg:order-1">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-manrope font-bold text-slate-primary mb-5 md:mb-6 leading-tight">
              {t('quartier_h2')}
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
              {t('quartier_p1')}
            </p>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              {t('quartier_p2')}
            </p>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Saint-Romuald%20Quebec%20neighborhood%20with%20bungalows%20and%20split-level%20houses%2C%20the%20Saint%20Lawrence%20river%20visible%20in%20the%20background%2C%20warm%20summer%20afternoon%20light%2C%20authentic%20suburban%20Quebec%20architecture%20from%201960s-1980s%2C%20tree-lined%20streets%2C%20no%20people%2C%20documentary%20photography%20style&width=600&height=450&seq=sr-quartier-1&orientation=squarish"
                alt="Maisons typiques bungalows à Saint-Romuald, Lévis avec vue sur le fleuve Saint-Laurent"
                className="w-full h-[300px] md:h-[400px] object-cover object-top"
                loading="lazy"
                width="600"
                height="450"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}